import React, { useEffect, useState } from 'react';

import SelectComponent from 'components/atoms/SelectComponent';
import LoadingWrapper from 'components/hoc/LoadingWrapper';

import { IFSluzbyPutData } from 'services/statniSprava/FSluzbaPut';
import { IIsinSelectData, isinSelectApi } from 'services/statniSprava/isinSelect';

interface IIsinSelect {
    disabled?: boolean;
    setIsDlt?: React.Dispatch<React.SetStateAction<boolean>>;
    onChange?: () => void;
}

const IsinSelect: React.FC<IIsinSelect> = ({ disabled, setIsDlt, onChange }) => {
    const sluzba = window.location.hash.split('/')[4] as keyof IFSluzbyPutData;
    const [loading, setLoading] = useState<boolean>(false);
    const [selectData, setSelectData] = useState<{ value: string | number; labelcz: string; labelen?: string }[]>([]);
    const [data, setData] = useState<IIsinSelectData>();

    useEffect(() => {
        setLoading(true);
        isinSelectApi(sluzba)
            .then(resp => {
                setData(resp);
                setSelectData(
                    resp.emise.map(e => {
                        return {
                            value: e.isin,
                            labelcz: e.isin
                        };
                    })
                );
            })
            .finally(() => setLoading(false));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <LoadingWrapper loading={loading}>
            <SelectComponent
                disabled={disabled}
                name="cval"
                labelParagraph="ISIN"
                labelCol={{
                    span: 8
                }}
                onChange={val => {
                    onChange?.();
                    setIsDlt?.(!!(data?.emise.filter(e => e.isin === val)[0].evidence === 'DLT'));
                }}
                data={selectData}
                isFormItem={true}
            />
        </LoadingWrapper>
    );
};

export default IsinSelect;
